export default __webpack_public_path__ + "f270980df31d894beaf08e2da3cf62d3.woff2";